<template>
  <div class="container">
    <component
      :is="listTitleHeadingType"
      :class="listTitleClass"
    >
      {{ listTitle }}
    </component>
    <p
      v-if="listText"
      v-dompurify-html="listText"
      :class="`list-text ${listTextClass} `"
    />
    <div
      :class="`${styleClass} ${wrapperClass}`"
    >
      <template
        v-for="(item, index) in listItems"
      >
        <template v-if="typeof item.href === 'string' && item.href && item.href.search(/^(http(s)?|\/\/)/) !== -1">
          <a
            v-show="((item.hide) ? seen : true)"
            :key="index"
            :href="item.href"
            :target="item.target"
            class="topic align-items-center"
            :class="{'d-flex':!((item.hide) ? seen : true)}"
          >
            <div
              v-if="item.img"
              class="topic-img"
            >
              <img
                :data-src="$t(item.img)"
                alt=""
                class="lazyload"
              >
            </div>
            <div class="topic-body">
              <div class="topic-title">
                {{ $t(item.title) }}
              </div>
              <div class="topic-subtitle">
                {{ $t(item.subtitle) }}
              </div>
            </div>
            <div class="topic-icon ml-auto">
              <i class="icon">
                <icon-chevron-right />
              </i>
            </div>
          </a>
        </template>

        <template v-else-if="item.href">
          <a
            v-show="((item.hide) ? seen : true)"
            :key="index"
            :href="arp_linkBuilder(item.href)"
            class="topic align-items-center"
            :class="{
              'has-img': item.img,
              'd-flex' :(!item.hide || seen) && ( !item.contentLink || ignoreContentLink),
              'topic-image':item.contentLink && !ignoreContentLink
            }"
            :title="titleOrEmpty(item)"
            :data-ident="`contentLinkListA${index}`"
            @click.prevent="arp_linkClicker(item.href)"
          >
            <div v-if="item.contentLink && !ignoreContentLink">
              <img
                :data-src="$t(item.contentLink.img)"
                :alt="$t(item.contentLink.alt)"
                class="lazyload"
              >
            </div>
            <div
              v-if="item.img"
              class="topic-img"
            >
              <img
                :data-src="$t(item.img)"
                alt=""
                class="lazyload"
              >
            </div>
            <template
              v-if="item.contentLink && !ignoreContentLink"
            >
              <component
                :is="itemTitleTag"
                :class="itemTitleClass"
              >
                <span>{{ $t(item.contentLink.head) }}</span> <small>{{ $t(item.contentLink.teaser) }}</small>
              </component>
            </template>
            <div
              v-else
              class="topic-body"
            >
              <div
                v-if="item.name"
                class="topic-title"
              >
                {{ $t(item.name) }}
              </div>
              <div
                v-else-if="item.title"
                class="topic-title"
              >
                {{ $t(item.title) }}
              </div>
              <div class="topic-subtitle">
                {{ $t(item.subtitle) }}
              </div>
            </div>
            <div
              v-if="!item.contentLink || ignoreContentLink"
              class="topic-icon ml-auto"
            >
              <i class="icon">
                <icon-chevron-right />
              </i>
            </div>
          </a>
        </template>

        <template v-else>
          <div
            v-show="(item.hide) ? seen : true"
            :key="index"
            class="topic d-flex align-items-center"
          >
            <div
              v-if="item.img"
              class="topic-img"
            >
              <img
                :data-src="$t(item.img)"
                alt=""
                class="lazyload"
              >
            </div>
            <div class="topic-body">
              <div class="topic-title">
                {{ $t(item.title) }}
              </div>
              <div class="topic-subtitle">
                {{ $t(item.subtitle) }}
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
    <div
      v-if="togglePresent"
      class="text-center"
    >
      <button
        class="btn btn-more"
        type="button"
        :data-ident="`contentLinkTggle`"
        @click="seen = !seen"
      >
        <i class="icon">
          <icon-chevron-up v-if="seen" />
          <icon-chevron-down v-else />
        </i>
        {{ showAll }}
      </button>
    </div>
  </div>
</template>

<script>
import 'lazysizes';

/* ICONS */
import DeviceHelper from 'mixins/DeviceHelper';
import AnchorRouterPush from 'mixins/AnchorRouterPush';
import IconChevronDown from 'ICON:IconChevronDown';
import IconChevronUp from 'ICON:IconChevronUp';
import IconChevronRight from 'ICON:IconChevronRight';

export default {
  name: 'ContentLinkList',
  components: {
    IconChevronDown,
    IconChevronUp,
    IconChevronRight,
    DeviceHelper,
  },
  mixins: [AnchorRouterPush, DeviceHelper],
  props: {
    listTitle: {
      type: String,
      default: '',
    },
    listText: {
      type: String,
      default: '',
    },
    listTextClass: {
      type: String,
      default: '',
    },
    listTitleClass: {
      type: String,
      default: 'h3 text-center',
    },
    listTitleHeadingType: {
      type: String,
      default: 'h2',
    },
    listMore: {
      type: [String, Boolean],
      default: false,
    },
    listElements: {
      type: Array,
      default: () => [],
    },
    itemTitleTag: {
      type: String,
      default: 'div',
    },
    itemTitleClass: {
      type: String,
      default: '',
    },
    styleClass: {
      type: String,
      default: '',
    },
    sort: {
      type: [Boolean, String],
      default: false,
    },
    wrapperClass: {
      type: String,
      default: 'topics',
    },
    ignoreContentLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mounted: false,
      seen: false,
    };
  },
  computed: {
    showAll() {
      let returnString = this.listMore;
      if (this.seen) {
        returnString = this.$t('common:showLess');
      }
      return returnString;
    },
    breakpoint() {
      return this.dh_breakpoint;
    },
    isMobile() {
      if (this.breakpoint === 'xs') {
        return true;
      } return false;
    },

    togglePresent() {
      // if there is one element with 'hide' given toggle is true
      const hideElement = this.listElements.find((element) => element.hide === true);
      return !!(hideElement);
    },
    listItems() {
      let list = [];
      if (this.sort === true) {
        if (!this.mounted) return this.listElements;
        const deUmlaute = {
          Ä: 'AE', Ü: 'UE', Ö: 'OE', ß: 'SS',
        };
        const sortedList = [...this.listElements].sort((a, b) => {
          const nameA = a.title.toUpperCase().replace(/[ÄÜÖß]/g, (m) => deUmlaute[m]); // ignore upper and lowercase
          const nameB = b.title.toUpperCase().replace(/[ÄÜÖß]/g, (m) => deUmlaute[m]); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        list = [...sortedList];
      } else if (this.sort === 'order') {
        const sortedList = [...this.listElements].sort((a, b) => {
          if (a.order < b.order) {
            return -1;
          }
          if (a.order > b.order) {
            return 1;
          }
          return 0;
        });

        if (this.styleClass === 'favorite-offers') {
          if (this.isMobile === true) {
            if (sortedList[4]) sortedList[4].hide = true;
            if (sortedList[5]) sortedList[5].hide = true;
          } else {
            if (sortedList[4]) sortedList[4].hide = false;
            if (sortedList[5]) sortedList[5].hide = false;
          }
        }
        list = [...sortedList];
      } else {
        list = [...this.listElements];
      }

      return list;
    },
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    titleOrEmpty(item) { // check if props exists, prefer contentLink.title,  if no title available, return empty string
      if (item.contentLink) {
        return this.$i18n.i18next.t(item.contentLink.title);
      }
      if (item.anchorTitle) { // different link-title that displayed name
        return this.$i18n.i18next.t(item.anchorTitle);
      }
      if (item.title) {
        return this.$i18n.i18next.t(item.title);
      }

      return '';
    },
  },
};
</script>
<style lang="scss" scoped> // client specific scss is added at the end

/* custom style-classes */
.about-team img {
  width: 60px;
  height: 60px;
}

.horizontal-full-width {
  grid-template-columns: repeat(1, 1fr) !important;
}
</style>
<style lang="scss" scoped src='scss/components/ContentLinkList.scss'></style>
